<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <linearGradient y2="3.654" x2="3.654" y1="36.346" x1="36.346" gradientUnits="userSpaceOnUse" id="f6317__a">
        <stop offset="0" stop-color="#52e6ff" />
        <stop offset="1" stop-color="#b0f4ff" />
      </linearGradient>
      <path d="M30 39H10c-5 0-9-4.1-9-9.1V10.1C1 5.1 5 1 10 1h20c5 0 9 4.1 9 9.1v19.8c0 5-4 9.1-9 9.1z" fill="url(#f6317__a)" />
      <path d="M9.7 29.6c-1 0-1.7-.8-1.7-1.7v-5.2c0-1 .8-1.7 1.7-1.7s1.7.8 1.7 1.7v5.2c0 1-.8 1.7-1.7 1.7zm9.4 0c-1 0-1.7-.8-1.7-1.7V17.7c0-1 .8-1.7 1.7-1.7 1 0 1.7.8 1.7 1.7v10.2c.1 1-.7 1.7-1.7 1.7zm9.5 0c-1 0-1.7-.8-1.7-1.7V12.1c0-1 .8-1.7 1.7-1.7s1.7.8 1.7 1.7v15.8c0 1-.8 1.7-1.7 1.7z" data-follow-fill="#fff" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
